export default {
  free_menu_items: "Free unlocked",
};
